import * as Immutable from "immutable";
import {
  getFieldNameForFieldValueInBrackets,
  isCompleteFieldName,
  isSpace,
  isTypeTerm,
  isExistsOperator
} from "views/components/searchbar/completions/token-helper";
const _fieldResult = (field, score = 1, valuePosition = false) => {
  const { name, type } = field;
  return {
    name,
    value: `${name}${valuePosition ? "" : ":"}`,
    score,
    meta: type.type
  };
};
export const existsOperator = {
  name: "_exists_",
  type: {
    type: "operator"
  }
};
const _matchesFieldName = (prefix) => (field) => {
  const result = field.name.indexOf(prefix);
  if (result < 0) {
    return 0;
  }
  return result === 0 ? 2 : 1;
};
const shouldShowSuggestions = ({
  tokens,
  currentTokenIdx,
  prefix
}) => {
  var _a;
  const currentToken = tokens[currentTokenIdx];
  const prevToken = (_a = tokens[currentTokenIdx - 1]) != null ? _a : null;
  if (isCompleteFieldName(currentToken) && prefix) {
    return true;
  }
  if (isTypeTerm(currentToken)) {
    if (isCompleteFieldName(prevToken) && !isExistsOperator(prevToken) || getFieldNameForFieldValueInBrackets(tokens, currentTokenIdx)) {
      return false;
    }
    if (!prevToken || isSpace(prevToken) || isExistsOperator(prevToken)) {
      return true;
    }
  }
  return false;
};
class FieldNameCompletion {
  constructor(staticSuggestions = [existsOperator]) {
    this.getCompletions = ({ tokens, currentTokenIdx, prevToken, prefix, fieldTypes }) => {
      const showSuggestions = shouldShowSuggestions({ tokens, currentTokenIdx, prefix });
      if (!showSuggestions) {
        return [];
      }
      const matchesFieldName = _matchesFieldName(prefix);
      const { all, query } = fieldTypes;
      const currentQueryFields = Immutable.List(Object.values(query));
      const valuePosition = isExistsOperator(prevToken);
      const allButInCurrent = Object.values(all).filter((field) => !query[field.name]);
      const fieldsToMatchIn = valuePosition ? [...currentQueryFields.toArray()] : [...this.staticSuggestions, ...currentQueryFields.toArray()];
      const currentQuery = fieldsToMatchIn.filter((field) => matchesFieldName(field) > 0).map((field) => _fieldResult(field, 10 + matchesFieldName(field), valuePosition));
      const allFields = allButInCurrent.filter((field) => matchesFieldName(field) > 0).map((field) => _fieldResult(field, 1 + matchesFieldName(field), valuePosition)).map((result) => ({ ...result, meta: `${result.meta} (not in streams)` }));
      return [...currentQuery, ...allFields];
    };
    this.staticSuggestions = staticSuggestions;
  }
}
export default FieldNameCompletion;
